import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

import services from 'api/services';
import { useFreecodeContextData } from 'hooks/useContext';
import { ObjectException } from 'global/errors';
import ConfirmModal from 'components/Modals/confirmModal';

const { FreecodeCreatorService } = services;

export default function CreateWipTestImplModal({ closeModal }) {
  const navigate = useNavigate();

  const { test } = useFreecodeContextData();

  const [loading, setLoading] = useState(false);

  const createWipTestImpl = () => {
    if (loading) return toast.error('Already loading');
    setLoading(true);

    const doConfirm = async () => {
      try {
        let response = await FreecodeCreatorService.createWipTestImplementation(test._id);
        if (response.error)
          throw new ObjectException(response.error?.message || 'WIP creation failed', 'response error');
        if (!response?._id) throw new ObjectException('Response missing new implementation id', 'response error');

        toast.success('new WIP created');
        navigate(`/freecode-creator/${test._id}?testImplId=${response._id}`);
        closeModal();
      } catch (e) {
        toast.error(typeof e === 'string' ? e : e?.message || 'Could not create new WIP');
      } finally {
        setLoading(false);
      }
    };
    doConfirm();
  };

  return (
    <ConfirmModal
      title="Confirmation"
      text="Do you want to create a new WIP implementation?"
      onCancel={() => !loading && closeModal()}
      onConfirm={createWipTestImpl}
      loading={loading}
    />
  );
}
